import { getAvaiblePreRegistration, buyPackage } from "@/services/pre-registration.service";
import { formatDateToHour, formatDate } from "@/utils/utils";

// initial state
const state = () => ({
  preRegistrationModel: {},
  avaiblePreRegistrations: {
    templates: [],
  },
});

// mutations
const mutations = {
  setPreRegistrationModel(state, data) {
    state.preRegistrationModel = data;
  },
  setAvaiblePreRegistrations(state, data) {
    state.avaiblePreRegistrations = data;
  },
};

// actions
const actions = {
  async loadAvaiblePreRegistration(vuexContext) {
    return await getAvaiblePreRegistration().then((response) => {
      let data = response.data.data;
      let templates = data?.templates;
      if (templates) {
        templates.forEach((element) => {
          element.currencyCode = element.currency?.currencyCode;
          element.educationTypeName = element.educationType?.name;
          element.levelName = element.level?.description;
          element.registerStartDate = formatDate(element.registerStartDate);
          element.registerEndDate = formatDate(element.registerEndDate);
          if (element.classDayAndTimes?.length > 0) {
            element.dayAndTimes = [];
            element.classDayAndTimes.forEach((dayTime) => {
              element.dayAndTimes.push({ day: dayTime.day.name, date: formatDateToHour(dayTime.startDate) + " - " + formatDateToHour(dayTime.endDate) });
            });
          }
          element.classStatusName = "";
          element.classStatusName += `${Number(element.classStatus?.endTime) - Number(element.classStatus?.startTime)} Saat / ${element.classStatus?.levels?.description}`;
          element.classStatusHour = Number(element.classStatus?.endTime) - Number(element.classStatus?.startTime) + " Saat";
          element.usageTime = Number(element.classStatus?.endTime) - Number(element.classStatus?.startTime);
        });
      }
      vuexContext.commit("setAvaiblePreRegistrations", data);
      return data;
    });
  },

  async buyPackage(vuexContext, data) {
    return await buyPackage(data).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  addPreRegistrationModel(vuexContext, data) {
    vuexContext.commit("setPreRegistrationModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
